export default __webpack_public_path__ + "static/media/demo_cortex.6352b5c4.png";